module.exports = __webpack_public_path__ + "img/restore.47776739.png";